import { useState } from 'react';

import { Alert, CloseButton, TextButton } from '@zillow/constellation-10';

import { useRentalManagerUserPropertyDetailsWebApiHandler_overview } from '@zg-rentals/ts-rental-manager-api-client-react-query';
import {
  emitClickCorrectMapPinLocationFromPostingPathEvent,
  EVENT_IDS,
} from '@zg-rentals/zillow-rental-manager/analytics/events/correctMapPin';

import MapPinAdjustmentRequestModal from '../../modals/MapPinAdjustmentRequestModal';

import { useAuth } from '../../AuthProvider';

type Props = {
  listingAlias: string;
};

const MapPinAdjustmentAlert = ({ listingAlias }: Props) => {
  const { user } = useAuth();
  const [showModal, setShowModal] = useState(false);

  const { data: overviewData } = useRentalManagerUserPropertyDetailsWebApiHandler_overview(
    { listingAlias },
    {
      enabled: Boolean(listingAlias),
      meta: { tags: ['property-overview'], context: { api: 'overview', details: 'MapPinAdjustmentAlert' } },
    },
  );

  if (!overviewData?.canSubmitFixMapPinRequest) {
    return null;
  }

  const handleClick = () => {
    if (user) {
      emitClickCorrectMapPinLocationFromPostingPathEvent({
        user,
        currentProperty: { listingAlias, ...overviewData.address },
      });
    }
    setShowModal(true);
  };

  return (
    <>
      <Alert
        tone="warning"
        role="alert"
        actionButton={
          <TextButton onClick={handleClick} data-eventid={EVENT_IDS.CLICK_CORRECT_MAP_PIN}>
            Correct map pin location
          </TextButton>
        }
        closeButton={<CloseButton />}
        css={{ marginBottom: '600' }}
      >
        Your property location may be incorrect. Contact us to fix it.
      </Alert>

      {showModal && (
        <MapPinAdjustmentRequestModal
          listingAlias={listingAlias}
          onClose={() => setShowModal(false)}
          isFromPostingPath={true}
        />
      )}
    </>
  );
};

export default MapPinAdjustmentAlert;
